const translations = {
    applyingTrialDiscountErrorMessage: 'Error applying trial discount',
    fetchingCustomerPortalErrorMessage: 'Error fetching manage subscriptions',
    fetchingCustomerSecretErrorMessage: 'Error fetching customer session',
    fetchingSubscriptionsErrorMessage: 'Error fetching subscriptions'
};

export default translations;
